exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\r\nFile Name: \t\tcustom.css\r\nDescription:  You can add your custom CSS here and it will overwrite template styles\r\n*/\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/node_modules/css-loader?{"sourceMap":false,"import":false}!C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/assets/css/custom.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/assets/css/custom.css
// module chunks = styles